import { render, staticRenderFns } from "./InvalidShareId.vue?vue&type=template&id=4171100c"
import script from "./InvalidShareId.vue?vue&type=script&lang=js"
export * from "./InvalidShareId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports